import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-footer',
  templateUrl: './uni-form-footer.component.html',
  styleUrls: ['./uni-form-footer.component.scss']
})
export class UniFormFooterComponent {}
